// extracted by mini-css-extract-plugin
module.exports = {"title":"ConfirmationSwitchModal_title__2pk_a"};